import { render, staticRenderFns } from "./about.vue?vue&type=template&id=5617e902&scoped=true&"
var script = {}
import style0 from "./about.vue?vue&type=style&index=0&id=5617e902&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5617e902",
  null
  
)

export default component.exports